<template>
  <v-container
    :style="$vuetify.theme.dark ? '' : 'background: #eeeeee'"
    style="min-height: 110vh"
  >
    <v-row class="mb-1">
      <v-col cols="12" md="3">
        <h2 class="mt-1">
          <span class="grey--text">{{ $t("instructions.title") }} </span>
        </h2>
      </v-col>
      <v-col offset="7" md="2" class="mt-1" style="text-align: right"> </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" v-if="loading"><LoadCard /></v-col>
      <v-col cols="12" v-else-if="instructions.length > 0">
        <TableInstruction :data="viewMessage" />
      </v-col>
      <v-col v-else>
        <v-card class="text-center py-16" elevation="0">
          <h3 class="gray-text ma-3">
            {{ $t("instructions.empty") }}
          </h3>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import LoadCard from "@/views/components/LoadCard.vue";
import TableInstruction from "./TableInstruction.vue";
import { mapActions, mapState, mapGetters } from "vuex";
export default {
  name: "instructions-page",
  components: { TableInstruction, LoadCard },
  data() {
    return {};
  },
  computed: {
    viewMessage() {
      return this.instructions.sort(function (a, b) {
        return new Date(b.created_at) - new Date(a.created_at);
      });
    },
    userMe() {
      return this.$store.getters["users/userMe"];
    },
    ...mapGetters("instructions", ["instructions", "loading"]),
  },

  methods: {
    ...mapActions("instructions", ["list"]),
  },

  mounted() {
    this.list();
  },
};
</script>
